// FILE: /src/Components/Publishing/QueuePostSkeleton.js (NEW FILE)

import React from 'react';
import { Skeleton } from 'antd';

const QueuePostSkeleton = () => {
    return (
        <div className="bg-white rounded-lg shadow-md border border-gray-200 flex flex-col">
            <header className="p-4 border-b flex justify-between items-start">
                <div className="flex items-center gap-2">
                    <Skeleton.Avatar active size="small" shape="circle" />
                    <Skeleton.Avatar active size="small" shape="circle" />
                </div>
                <Skeleton.Input style={{ width: 80, height: 22 }} active size="small" />
            </header>
            <div className="p-4 flex-grow">
                <Skeleton.Input style={{ width: 120, height: 18 }} active size="small" />
                <Skeleton paragraph={{ rows: 2, width: '100%' }} className="mt-2" active />
                <Skeleton.Image style={{ width: '100%', height: 160, marginTop: 12 }} active />
            </div>
            <footer className="p-2 border-t flex justify-end items-center gap-1">
                <Skeleton.Button active size="small" />
                <Skeleton.Button active size="small" />
                <Skeleton.Button active size="small" />
            </footer>
        </div>
    );
};

export default QueuePostSkeleton;